import { TbTrophy } from "react-icons/tb";
import Typography from "../../../componentsNew/Typography";
import { FaTrophy, FaTrash } from "react-icons/fa";

export function LinkReferencia({position = 0, title = "", url="", description="", thumb="", remover}) {
    return (
        <div className="border rounded-lg p-2 shadow-md w-96 bg-white">
            <div className="flex items-center mt-2">
                {position == 1 && <TbTrophy size={24} className="text-sucess-main mr-2" />}
                {position > 1 && <Typography component="body-secundary-bold" className="text-gray-700 mr-2">{position}º</Typography>}
            </div>
            <a href={url} target="_blank" className="text-blue-600 font-semibold text-lg mt-2 block hover:underline">
                {title}
            </a>
            <p className="text-gray-600 text-sm mt-1">
                {description}
            </p>
            <span onClick={() => remover(position)} className="flex justify-end items-center text-error-main mt-3 cursor-pointer">
                <FaTrash  className="mr-2" /> Remover
            </span>
        </div>
    )
}